import React from 'react';

const Facebook = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 21.4059C16.9706 21.4059 21 17.3764 21 12.4059C21 7.43532 16.9706 3.40588 12 3.40588C7.02944 3.40588 3 7.43532 3 12.4059C3 17.3764 7.02944 21.4059 12 21.4059Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15.75 8.6559H14.25C13.9542 8.65466 13.661 8.71201 13.3875 8.82465C13.1139 8.93728 12.8654 9.10297 12.6562 9.31215C12.4471 9.52133 12.2814 9.76986 12.1687 10.0434C12.0561 10.3169 11.9987 10.6101 12 10.9059V21.4059"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fill="none"
      d="M9 13.9059H15"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Facebook;
